import i18n from '../i18n';
import { formatCalendarDate } from './calendarDate';

/**
 * The task-count window in the UI's language: "Since Jan 1, 2026" / "desde el 1 ene 2026".
 *
 * The API sends the window's first DAY (`taskCountSince`, `yyyy-MM-dd`) so the UI can word it —
 * fleet i18n, DP-I18N-3: the server never writes UI text in a language. `serverLabel` is the English
 * `taskCountPeriod` an API that predates that field still sends; it is shown only then (the
 * deploy-skew case). With neither, `fallback`.
 */
export function taskWindowLabel(
  since: string | null | undefined,
  serverLabel: string | null | undefined,
  fallback: string,
): string {
  if (since) return i18n.t('common.since', { date: formatCalendarDate(since) });
  return serverLabel || fallback;
}

/** The default window, Jan 1 of this year, worded in the UI's language. */
export function sinceStartOfYear(now: Date = new Date()): string {
  return i18n.t('common.since', { date: formatCalendarDate(`${now.getFullYear()}-01-01`) });
}
